import { render } from "./driver_message_list.vue?vue&type=template&id=b64a2e50&scoped=true&ts=true"
import script from "./driver_message_list.vue?vue&type=script&lang=ts"
export * from "./driver_message_list.vue?vue&type=script&lang=ts"

import "./driver_message_list.vue?vue&type=style&index=0&id=b64a2e50&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64a2e50"]])

export default __exports__